<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.21607 16.9593L9.21462 16.958C6.61966 14.6498 4.54731 12.8014 3.112 11.0789C1.68704 9.36884 1 7.90904 1 6.3951C1 3.93556 2.95284 2 5.5 2C6.94479 2 8.34274 2.66486 9.24741 3.69881L10 4.55896L10.7526 3.69881C11.6573 2.66486 13.0552 2 14.5 2C17.0472 2 19 3.93556 19 6.3951C19 7.90904 18.313 9.36884 16.888 11.0789C15.4527 12.8014 13.3803 14.6498 10.7854 16.958L10.7839 16.9593L10 17.6593L9.21607 16.9593Z" stroke="black" stroke-width="2" />
  </svg>
</template>

<script>
  export default {
    name: "FavIcon"
  }
</script>